module.exports = __webpack_public_path__ + "img/breaking-img.0001a9a.png";